/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cov_u8khnw8f0 = function () {
  var path = '/builds/CS-Development/overlay-messaging/src/main/logger.js',
      hash = '2fd0475faeea676a4e452cc974dbb3e2b5c37ff6',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/builds/CS-Development/overlay-messaging/src/main/logger.js',
    statementMap: {
      '0': {
        start: {
          line: 2,
          column: 2
        },
        end: {
          line: 12,
          column: 4
        }
      },
      '1': {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 10,
          column: 5
        }
      },
      '2': {
        start: {
          line: 5,
          column: 6
        },
        end: {
          line: 9,
          column: 7
        }
      },
      '3': {
        start: {
          line: 6,
          column: 8
        },
        end: {
          line: 6,
          column: 40
        }
      },
      '4': {
        start: {
          line: 7,
          column: 13
        },
        end: {
          line: 9,
          column: 7
        }
      },
      '5': {
        start: {
          line: 8,
          column: 8
        },
        end: {
          line: 8,
          column: 41
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 1,
            column: 15
          },
          end: {
            line: 1,
            column: 16
          }
        },
        loc: {
          start: {
            line: 1,
            column: 31
          },
          end: {
            line: 13,
            column: 1
          }
        },
        line: 1
      },
      '1': {
        name: 'logger',
        decl: {
          start: {
            line: 2,
            column: 18
          },
          end: {
            line: 2,
            column: 24
          }
        },
        loc: {
          start: {
            line: 2,
            column: 34
          },
          end: {
            line: 12,
            column: 3
          }
        },
        line: 2
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 4,
            column: 4
          },
          end: {
            line: 10,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 4,
            column: 4
          },
          end: {
            line: 10,
            column: 5
          }
        }, {
          start: {
            line: 4,
            column: 4
          },
          end: {
            line: 10,
            column: 5
          }
        }],
        line: 4
      },
      '1': {
        loc: {
          start: {
            line: 5,
            column: 6
          },
          end: {
            line: 9,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 5,
            column: 6
          },
          end: {
            line: 9,
            column: 7
          }
        }, {
          start: {
            line: 5,
            column: 6
          },
          end: {
            line: 9,
            column: 7
          }
        }],
        line: 5
      },
      '2': {
        loc: {
          start: {
            line: 5,
            column: 10
          },
          end: {
            line: 5,
            column: 44
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 5,
            column: 10
          },
          end: {
            line: 5,
            column: 27
          }
        }, {
          start: {
            line: 5,
            column: 31
          },
          end: {
            line: 5,
            column: 44
          }
        }],
        line: 5
      },
      '3': {
        loc: {
          start: {
            line: 7,
            column: 13
          },
          end: {
            line: 9,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 7,
            column: 13
          },
          end: {
            line: 9,
            column: 7
          }
        }, {
          start: {
            line: 7,
            column: 13
          },
          end: {
            line: 9,
            column: 7
          }
        }],
        line: 7
      },
      '4': {
        loc: {
          start: {
            line: 7,
            column: 17
          },
          end: {
            line: 7,
            column: 73
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 7,
            column: 17
          },
          end: {
            line: 7,
            column: 55
          }
        }, {
          start: {
            line: 7,
            column: 59
          },
          end: {
            line: 7,
            column: 73
          }
        }],
        line: 7
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0
    },
    f: {
      '0': 0,
      '1': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (level) {
  cov_u8khnw8f0.f[0]++;
  cov_u8khnw8f0.s[0]++;

  return function logger() {
    cov_u8khnw8f0.f[1]++;
    cov_u8khnw8f0.s[1]++;

    /* eslint-disable no-console */
    if (console) {
      cov_u8khnw8f0.b[0][0]++;
      cov_u8khnw8f0.s[2]++;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if ((cov_u8khnw8f0.b[2][0]++, level === 'error') && (cov_u8khnw8f0.b[2][1]++, console.error)) {
        cov_u8khnw8f0.b[1][0]++;
        cov_u8khnw8f0.s[3]++;

        console.error.apply(null, args);
      } else {
          cov_u8khnw8f0.b[1][1]++;
          cov_u8khnw8f0.s[4]++;
          if ((cov_u8khnw8f0.b[4][0]++, "production" === 'development') && (cov_u8khnw8f0.b[4][1]++, console[level])) {
            cov_u8khnw8f0.b[3][0]++;
            cov_u8khnw8f0.s[5]++;

            console[level].apply(null, args);
          } else {
            cov_u8khnw8f0.b[3][1]++;
          }
        }
    } else {
      cov_u8khnw8f0.b[0][1]++;
    }
    /* eslint-enable */
  };
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _overlayMessaging = __webpack_require__(3);

var _overlayMessaging2 = _interopRequireDefault(_overlayMessaging);

var _overlayCookieDisclaimer = __webpack_require__(13);

var _overlayCookieDisclaimer2 = _interopRequireDefault(_overlayCookieDisclaimer);

var _logger = __webpack_require__(14);

var _logger2 = _interopRequireDefault(_logger);

var _messageBusGetter = __webpack_require__(15);

var _messageBusGetter2 = _interopRequireDefault(_messageBusGetter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logError = (0, _logger2.default)('error');

var messageBus = (0, _messageBusGetter2.default)();

if (!messageBus) {
  logError('POPOVERS: no messageBus / AnalyticsPubSub found');
}

(0, _overlayCookieDisclaimer2.default)(messageBus);
(0, _overlayMessaging2.default)(messageBus);

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cov_166zslfgx2 = function () {
  var path = '/builds/CS-Development/overlay-messaging/src/main/index.js',
      hash = '6175ddfe8800d6730460fd99bc60de6460f4b782',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/builds/CS-Development/overlay-messaging/src/main/index.js',
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _app = __webpack_require__(4);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_app).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cov_qo681cy34 = function () {
  var path = '/builds/CS-Development/overlay-messaging/src/main/app.js',
      hash = '920894e7b14e81deab7a0af460e2198c9349442f',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/builds/CS-Development/overlay-messaging/src/main/app.js',
    statementMap: {
      '0': {
        start: {
          line: 4,
          column: 27
        },
        end: {
          line: 4,
          column: 42
        }
      },
      '1': {
        start: {
          line: 6,
          column: 17
        },
        end: {
          line: 6,
          column: 35
        }
      },
      '2': {
        start: {
          line: 12,
          column: 27
        },
        end: {
          line: 16,
          column: 1
        }
      },
      '3': {
        start: {
          line: 13,
          column: 2
        },
        end: {
          line: 15,
          column: 3
        }
      },
      '4': {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 14,
          column: 44
        }
      },
      '5': {
        start: {
          line: 22,
          column: 24
        },
        end: {
          line: 26,
          column: 44
        }
      },
      '6': {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 26,
          column: 44
        }
      },
      '7': {
        start: {
          line: 36,
          column: 2
        },
        end: {
          line: 39,
          column: 3
        }
      },
      '8': {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 48
        }
      },
      '9': {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 38,
          column: 16
        }
      },
      '10': {
        start: {
          line: 40,
          column: 2
        },
        end: {
          line: 40,
          column: 33
        }
      },
      '11': {
        start: {
          line: 41,
          column: 2
        },
        end: {
          line: 45,
          column: 3
        }
      },
      '12': {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 41
        }
      },
      '13': {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 72
        }
      },
      '14': {
        start: {
          line: 46,
          column: 2
        },
        end: {
          line: 46,
          column: 24
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 12,
            column: 27
          },
          end: {
            line: 12,
            column: 28
          }
        },
        loc: {
          start: {
            line: 12,
            column: 41
          },
          end: {
            line: 16,
            column: 1
          }
        },
        line: 12
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 22,
            column: 24
          },
          end: {
            line: 22,
            column: 25
          }
        },
        loc: {
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 26,
            column: 44
          }
        },
        line: 23
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 35,
            column: 15
          },
          end: {
            line: 35,
            column: 16
          }
        },
        loc: {
          start: {
            line: 35,
            column: 41
          },
          end: {
            line: 47,
            column: 1
          }
        },
        line: 35
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 15,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 15,
            column: 3
          }
        }, {
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 15,
            column: 3
          }
        }],
        line: 13
      },
      '1': {
        loc: {
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 26,
            column: 44
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 23,
            column: 21
          }
        }, {
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 24,
            column: 35
          }
        }, {
          start: {
            line: 25,
            column: 3
          },
          end: {
            line: 25,
            column: 43
          }
        }, {
          start: {
            line: 25,
            column: 47
          },
          end: {
            line: 25,
            column: 93
          }
        }, {
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 26,
            column: 44
          }
        }],
        line: 23
      },
      '2': {
        loc: {
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 39,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 39,
            column: 3
          }
        }, {
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 39,
            column: 3
          }
        }],
        line: 36
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0, 0, 0, 0],
      '2': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cookiesConsent = __webpack_require__(5);

var _cookiesConsent2 = _interopRequireDefault(_cookiesConsent);

var _logger = __webpack_require__(1);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CRM_MESSAGEBUS_KEY = (cov_qo681cy34.s[0]++, 'crmMessageBus');

var logError = (cov_qo681cy34.s[1]++, (0, _logger2.default)('error'));

/**
 * Sets a global object with the messageBus instance to be used by analytics.
 * @param {Object} messageBus
 */
cov_qo681cy34.s[2]++;
var setMessageBusConst = function setMessageBusConst(messageBus) {
  cov_qo681cy34.f[0]++;
  cov_qo681cy34.s[3]++;

  if (!window[CRM_MESSAGEBUS_KEY]) {
    cov_qo681cy34.b[0][0]++;
    cov_qo681cy34.s[4]++;

    window[CRM_MESSAGEBUS_KEY] = messageBus;
  } else {
    cov_qo681cy34.b[0][1]++;
  }
};

/**
 * checks if the messageBus received is correct
 * @param {Object} messageBus a messageBus instance
 */
cov_qo681cy34.s[5]++;
var checkMessageBus = function checkMessageBus(messageBus) {
  cov_qo681cy34.f[1]++;
  cov_qo681cy34.s[6]++;
  return (cov_qo681cy34.b[1][0]++, messageBus !== null) && (cov_qo681cy34.b[1][1]++, typeof messageBus !== 'undefined') && ((cov_qo681cy34.b[1][2]++, typeof messageBus.publish === 'function') || (cov_qo681cy34.b[1][3]++, typeof messageBus.publishSticky === 'function')) && (cov_qo681cy34.b[1][4]++, typeof messageBus.subscribe === 'function');
};

/**
 * function that inits all the components available
 * @function
 * @param {Object} messageBus A messageBus instance
 * @param {string} langCode A language code
 * @returns {void}
 */

exports.default = function (messageBus, langCode) {
  cov_qo681cy34.f[2]++;
  cov_qo681cy34.s[7]++;

  if (!checkMessageBus(messageBus)) {
    cov_qo681cy34.b[2][0]++;
    cov_qo681cy34.s[8]++;

    logError('POPOVERS: no messageBus defined');
    cov_qo681cy34.s[9]++;
    return null;
  } else {
    cov_qo681cy34.b[2][1]++;
  }
  cov_qo681cy34.s[10]++;
  setMessageBusConst(messageBus);
  cov_qo681cy34.s[11]++;
  try {
    cov_qo681cy34.s[12]++;

    (0, _cookiesConsent2.default)(messageBus, langCode);
  } catch (e) {
    cov_qo681cy34.s[13]++;

    logError('POPOVERS: error initializating cookie banner', e.message);
  }
  cov_qo681cy34.s[14]++;
  return _cookiesConsent2.default;
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(fetch) {

var cov_1murhee27c = function () {
  var path = '/builds/CS-Development/overlay-messaging/src/main/components/cookies-consent/index.js',
      hash = '875147aa48880c9912060b14a3e189fc1f45980a',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/builds/CS-Development/overlay-messaging/src/main/components/cookies-consent/index.js',
    statementMap: {
      '0': {
        start: {
          line: 22,
          column: 17
        },
        end: {
          line: 22,
          column: 35
        }
      },
      '1': {
        start: {
          line: 23,
          column: 16
        },
        end: {
          line: 23,
          column: 32
        }
      },
      '2': {
        start: {
          line: 29,
          column: 22
        },
        end: {
          line: 36,
          column: 1
        }
      },
      '3': {
        start: {
          line: 30,
          column: 21
        },
        end: {
          line: 30,
          column: 41
        }
      },
      '4': {
        start: {
          line: 31,
          column: 19
        },
        end: {
          line: 31,
          column: 50
        }
      },
      '5': {
        start: {
          line: 32,
          column: 2
        },
        end: {
          line: 35,
          column: 4
        }
      },
      '6': {
        start: {
          line: 44,
          column: 18
        },
        end: {
          line: 58,
          column: 1
        }
      },
      '7': {
        start: {
          line: 45,
          column: 20
        },
        end: {
          line: 49,
          column: 3
        }
      },
      '8': {
        start: {
          line: 50,
          column: 17
        },
        end: {
          line: 50,
          column: 19
        }
      },
      '9': {
        start: {
          line: 51,
          column: 2
        },
        end: {
          line: 56,
          column: 5
        }
      },
      '10': {
        start: {
          line: 52,
          column: 22
        },
        end: {
          line: 52,
          column: 47
        }
      },
      '11': {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 55,
          column: 5
        }
      },
      '12': {
        start: {
          line: 54,
          column: 6
        },
        end: {
          line: 54,
          column: 38
        }
      },
      '13': {
        start: {
          line: 57,
          column: 2
        },
        end: {
          line: 57,
          column: 16
        }
      },
      '14': {
        start: {
          line: 64,
          column: 26
        },
        end: {
          line: 66,
          column: 1
        }
      },
      '15': {
        start: {
          line: 65,
          column: 2
        },
        end: {
          line: 65,
          column: 71
        }
      },
      '16': {
        start: {
          line: 69,
          column: 2
        },
        end: {
          line: 69,
          column: 72
        }
      },
      '17': {
        start: {
          line: 78,
          column: 18
        },
        end: {
          line: 114,
          column: 1
        }
      },
      '18': {
        start: {
          line: 86,
          column: 23
        },
        end: {
          line: 98,
          column: 3
        }
      },
      '19': {
        start: {
          line: 87,
          column: 4
        },
        end: {
          line: 97,
          column: 9
        }
      },
      '20': {
        start: {
          line: 88,
          column: 24
        },
        end: {
          line: 88,
          column: 39
        }
      },
      '21': {
        start: {
          line: 90,
          column: 8
        },
        end: {
          line: 92,
          column: 9
        }
      },
      '22': {
        start: {
          line: 91,
          column: 10
        },
        end: {
          line: 91,
          column: 28
        }
      },
      '23': {
        start: {
          line: 93,
          column: 8
        },
        end: {
          line: 93,
          column: 48
        }
      },
      '24': {
        start: {
          line: 96,
          column: 8
        },
        end: {
          line: 96,
          column: 66
        }
      },
      '25': {
        start: {
          line: 101,
          column: 4
        },
        end: {
          line: 101,
          column: 99
        }
      },
      '26': {
        start: {
          line: 103,
          column: 2
        },
        end: {
          line: 113,
          column: 4
        }
      },
      '27': {
        start: {
          line: 107,
          column: 8
        },
        end: {
          line: 107,
          column: 51
        }
      },
      '28': {
        start: {
          line: 108,
          column: 8
        },
        end: {
          line: 111,
          column: 13
        }
      },
      '29': {
        start: {
          line: 110,
          column: 12
        },
        end: {
          line: 110,
          column: 56
        }
      },
      '30': {
        start: {
          line: 122,
          column: 22
        },
        end: {
          line: 129,
          column: 1
        }
      },
      '31': {
        start: {
          line: 123,
          column: 27
        },
        end: {
          line: 126,
          column: 3
        }
      },
      '32': {
        start: {
          line: 124,
          column: 4
        },
        end: {
          line: 124,
          column: 65
        }
      },
      '33': {
        start: {
          line: 125,
          column: 4
        },
        end: {
          line: 125,
          column: 40
        }
      },
      '34': {
        start: {
          line: 128,
          column: 2
        },
        end: {
          line: 128,
          column: 81
        }
      },
      '35': {
        start: {
          line: 137,
          column: 20
        },
        end: {
          line: 150,
          column: 1
        }
      },
      '36': {
        start: {
          line: 138,
          column: 17
        },
        end: {
          line: 138,
          column: 46
        }
      },
      '37': {
        start: {
          line: 139,
          column: 2
        },
        end: {
          line: 147,
          column: 3
        }
      },
      '38': {
        start: {
          line: 140,
          column: 4
        },
        end: {
          line: 145,
          column: 5
        }
      },
      '39': {
        start: {
          line: 141,
          column: 6
        },
        end: {
          line: 141,
          column: 38
        }
      },
      '40': {
        start: {
          line: 143,
          column: 6
        },
        end: {
          line: 143,
          column: 63
        }
      },
      '41': {
        start: {
          line: 144,
          column: 6
        },
        end: {
          line: 144,
          column: 19
        }
      },
      '42': {
        start: {
          line: 146,
          column: 4
        },
        end: {
          line: 146,
          column: 92
        }
      },
      '43': {
        start: {
          line: 148,
          column: 2
        },
        end: {
          line: 148,
          column: 55
        }
      },
      '44': {
        start: {
          line: 149,
          column: 2
        },
        end: {
          line: 149,
          column: 15
        }
      },
      '45': {
        start: {
          line: 158,
          column: 24
        },
        end: {
          line: 160,
          column: 1
        }
      },
      '46': {
        start: {
          line: 159,
          column: 2
        },
        end: {
          line: 159,
          column: 47
        }
      },
      '47': {
        start: {
          line: 168,
          column: 14
        },
        end: {
          line: 171,
          column: 1
        }
      },
      '48': {
        start: {
          line: 169,
          column: 2
        },
        end: {
          line: 169,
          column: 18
        }
      },
      '49': {
        start: {
          line: 170,
          column: 2
        },
        end: {
          line: 170,
          column: 29
        }
      },
      '50': {
        start: {
          line: 179,
          column: 23
        },
        end: {
          line: 192,
          column: 1
        }
      },
      '51': {
        start: {
          line: 180,
          column: 2
        },
        end: {
          line: 180,
          column: 32
        }
      },
      '52': {
        start: {
          line: 181,
          column: 2
        },
        end: {
          line: 181,
          column: 59
        }
      },
      '53': {
        start: {
          line: 183,
          column: 2
        },
        end: {
          line: 186,
          column: 3
        }
      },
      '54': {
        start: {
          line: 184,
          column: 4
        },
        end: {
          line: 184,
          column: 74
        }
      },
      '55': {
        start: {
          line: 185,
          column: 4
        },
        end: {
          line: 185,
          column: 16
        }
      },
      '56': {
        start: {
          line: 187,
          column: 2
        },
        end: {
          line: 189,
          column: 3
        }
      },
      '57': {
        start: {
          line: 188,
          column: 4
        },
        end: {
          line: 188,
          column: 27
        }
      },
      '58': {
        start: {
          line: 190,
          column: 2
        },
        end: {
          line: 190,
          column: 61
        }
      },
      '59': {
        start: {
          line: 191,
          column: 2
        },
        end: {
          line: 191,
          column: 14
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 29,
            column: 22
          },
          end: {
            line: 29,
            column: 23
          }
        },
        loc: {
          start: {
            line: 29,
            column: 30
          },
          end: {
            line: 36,
            column: 1
          }
        },
        line: 29
      },
      '1': {
        name: 'mapLabels',
        decl: {
          start: {
            line: 44,
            column: 27
          },
          end: {
            line: 44,
            column: 36
          }
        },
        loc: {
          start: {
            line: 44,
            column: 48
          },
          end: {
            line: 58,
            column: 1
          }
        },
        line: 44
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 51,
            column: 20
          },
          end: {
            line: 51,
            column: 21
          }
        },
        loc: {
          start: {
            line: 51,
            column: 30
          },
          end: {
            line: 56,
            column: 3
          }
        },
        line: 51
      },
      '3': {
        name: 'getLangFromConfig',
        decl: {
          start: {
            line: 64,
            column: 35
          },
          end: {
            line: 64,
            column: 52
          }
        },
        loc: {
          start: {
            line: 64,
            column: 55
          },
          end: {
            line: 66,
            column: 1
          }
        },
        line: 64
      },
      '4': {
        name: 'getSportsbookLocale',
        decl: {
          start: {
            line: 68,
            column: 9
          },
          end: {
            line: 68,
            column: 28
          }
        },
        loc: {
          start: {
            line: 68,
            column: 31
          },
          end: {
            line: 70,
            column: 1
          }
        },
        line: 68
      },
      '5': {
        name: 'getLabels',
        decl: {
          start: {
            line: 78,
            column: 27
          },
          end: {
            line: 78,
            column: 36
          }
        },
        loc: {
          start: {
            line: 78,
            column: 47
          },
          end: {
            line: 114,
            column: 1
          }
        },
        line: 78
      },
      '6': {
        name: 'fetchContent',
        decl: {
          start: {
            line: 86,
            column: 32
          },
          end: {
            line: 86,
            column: 44
          }
        },
        loc: {
          start: {
            line: 86,
            column: 50
          },
          end: {
            line: 98,
            column: 3
          }
        },
        line: 86
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 88,
            column: 12
          },
          end: {
            line: 88,
            column: 13
          }
        },
        loc: {
          start: {
            line: 88,
            column: 24
          },
          end: {
            line: 88,
            column: 39
          }
        },
        line: 88
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 89,
            column: 12
          },
          end: {
            line: 89,
            column: 13
          }
        },
        loc: {
          start: {
            line: 89,
            column: 32
          },
          end: {
            line: 94,
            column: 7
          }
        },
        line: 89
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 95,
            column: 12
          },
          end: {
            line: 95,
            column: 13
          }
        },
        loc: {
          start: {
            line: 95,
            column: 20
          },
          end: {
            line: 97,
            column: 7
          }
        },
        line: 95
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 106,
            column: 13
          },
          end: {
            line: 106,
            column: 14
          }
        },
        loc: {
          start: {
            line: 106,
            column: 23
          },
          end: {
            line: 112,
            column: 7
          }
        },
        line: 106
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 109,
            column: 17
          },
          end: {
            line: 109,
            column: 18
          }
        },
        loc: {
          start: {
            line: 109,
            column: 27
          },
          end: {
            line: 111,
            column: 11
          }
        },
        line: 109
      },
      '12': {
        name: 'initListeners',
        decl: {
          start: {
            line: 122,
            column: 31
          },
          end: {
            line: 122,
            column: 44
          }
        },
        loc: {
          start: {
            line: 122,
            column: 47
          },
          end: {
            line: 129,
            column: 1
          }
        },
        line: 122
      },
      '13': {
        name: 'handleMessages',
        decl: {
          start: {
            line: 123,
            column: 36
          },
          end: {
            line: 123,
            column: 50
          }
        },
        loc: {
          start: {
            line: 123,
            column: 58
          },
          end: {
            line: 126,
            column: 3
          }
        },
        line: 123
      },
      '14': {
        name: 'isIOSNative',
        decl: {
          start: {
            line: 137,
            column: 29
          },
          end: {
            line: 137,
            column: 40
          }
        },
        loc: {
          start: {
            line: 137,
            column: 43
          },
          end: {
            line: 150,
            column: 1
          }
        },
        line: 137
      },
      '15': {
        name: 'meetsConditions',
        decl: {
          start: {
            line: 158,
            column: 33
          },
          end: {
            line: 158,
            column: 48
          }
        },
        loc: {
          start: {
            line: 158,
            column: 51
          },
          end: {
            line: 160,
            column: 1
          }
        },
        line: 158
      },
      '16': {
        name: 'start',
        decl: {
          start: {
            line: 168,
            column: 23
          },
          end: {
            line: 168,
            column: 28
          }
        },
        loc: {
          start: {
            line: 168,
            column: 39
          },
          end: {
            line: 171,
            column: 1
          }
        },
        line: 168
      },
      '17': {
        name: 'cookiesOverlay',
        decl: {
          start: {
            line: 179,
            column: 32
          },
          end: {
            line: 179,
            column: 46
          }
        },
        loc: {
          start: {
            line: 179,
            column: 69
          },
          end: {
            line: 192,
            column: 1
          }
        },
        line: 179
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 34,
            column: 4
          },
          end: {
            line: 34,
            column: 69
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 34,
            column: 20
          },
          end: {
            line: 34,
            column: 64
          }
        }, {
          start: {
            line: 34,
            column: 67
          },
          end: {
            line: 34,
            column: 69
          }
        }],
        line: 34
      },
      '1': {
        loc: {
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 55,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 55,
            column: 5
          }
        }, {
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 55,
            column: 5
          }
        }],
        line: 53
      },
      '2': {
        loc: {
          start: {
            line: 65,
            column: 9
          },
          end: {
            line: 65,
            column: 70
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 65,
            column: 9
          },
          end: {
            line: 65,
            column: 32
          }
        }, {
          start: {
            line: 65,
            column: 36
          },
          end: {
            line: 65,
            column: 70
          }
        }],
        line: 65
      },
      '3': {
        loc: {
          start: {
            line: 69,
            column: 9
          },
          end: {
            line: 69,
            column: 71
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 69,
            column: 9
          },
          end: {
            line: 69,
            column: 18
          }
        }, {
          start: {
            line: 69,
            column: 22
          },
          end: {
            line: 69,
            column: 42
          }
        }, {
          start: {
            line: 69,
            column: 46
          },
          end: {
            line: 69,
            column: 71
          }
        }],
        line: 69
      },
      '4': {
        loc: {
          start: {
            line: 90,
            column: 8
          },
          end: {
            line: 92,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 90,
            column: 8
          },
          end: {
            line: 92,
            column: 9
          }
        }, {
          start: {
            line: 90,
            column: 8
          },
          end: {
            line: 92,
            column: 9
          }
        }],
        line: 90
      },
      '5': {
        loc: {
          start: {
            line: 101,
            column: 4
          },
          end: {
            line: 101,
            column: 99
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 101,
            column: 4
          },
          end: {
            line: 101,
            column: 12
          }
        }, {
          start: {
            line: 101,
            column: 16
          },
          end: {
            line: 101,
            column: 51
          }
        }, {
          start: {
            line: 101,
            column: 55
          },
          end: {
            line: 101,
            column: 74
          }
        }, {
          start: {
            line: 101,
            column: 78
          },
          end: {
            line: 101,
            column: 99
          }
        }],
        line: 101
      },
      '6': {
        loc: {
          start: {
            line: 139,
            column: 2
          },
          end: {
            line: 147,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 139,
            column: 2
          },
          end: {
            line: 147,
            column: 3
          }
        }, {
          start: {
            line: 139,
            column: 2
          },
          end: {
            line: 147,
            column: 3
          }
        }],
        line: 139
      },
      '7': {
        loc: {
          start: {
            line: 146,
            column: 11
          },
          end: {
            line: 146,
            column: 91
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 146,
            column: 11
          },
          end: {
            line: 146,
            column: 29
          }
        }, {
          start: {
            line: 146,
            column: 33
          },
          end: {
            line: 146,
            column: 61
          }
        }, {
          start: {
            line: 146,
            column: 65
          },
          end: {
            line: 146,
            column: 91
          }
        }],
        line: 146
      },
      '8': {
        loc: {
          start: {
            line: 181,
            column: 12
          },
          end: {
            line: 181,
            column: 58
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 181,
            column: 12
          },
          end: {
            line: 181,
            column: 36
          }
        }, {
          start: {
            line: 181,
            column: 40
          },
          end: {
            line: 181,
            column: 58
          }
        }],
        line: 181
      },
      '9': {
        loc: {
          start: {
            line: 183,
            column: 2
          },
          end: {
            line: 186,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 183,
            column: 2
          },
          end: {
            line: 186,
            column: 3
          }
        }, {
          start: {
            line: 183,
            column: 2
          },
          end: {
            line: 186,
            column: 3
          }
        }],
        line: 183
      },
      '10': {
        loc: {
          start: {
            line: 187,
            column: 2
          },
          end: {
            line: 189,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 187,
            column: 2
          },
          end: {
            line: 189,
            column: 3
          }
        }, {
          start: {
            line: 187,
            column: 2
          },
          end: {
            line: 189,
            column: 3
          }
        }],
        line: 187
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0, 0],
      '4': [0, 0],
      '5': [0, 0, 0, 0],
      '6': [0, 0],
      '7': [0, 0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _logger = __webpack_require__(1);

var _logger2 = _interopRequireDefault(_logger);

var _constants = __webpack_require__(11);

var _cookieAdapter = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var moduleMessageBus = void 0;
var publish = void 0;
var logError = (cov_1murhee27c.s[0]++, (0, _logger2.default)('error'));
var logInfo = (cov_1murhee27c.s[1]++, (0, _logger2.default)('log'));
/**
 * forms the correct url language-dependant to get content from
 * @param {string} lang represents the language to retrieve content from ('en-gb', 'de-de'...)
 * @returns {string} url
 */
cov_1murhee27c.s[2]++;
var getContentUrl = function getContentUrl(lang) {
  cov_1murhee27c.f[0]++;

  var currentUrl = (cov_1murhee27c.s[3]++, window.location.href);
  var position = (cov_1murhee27c.s[4]++, currentUrl.search(/-pp(1|2|3)/));
  cov_1murhee27c.s[5]++;
  return (_constants.CRM_COOKIES_CONTENT_URL + '&meta_language=' + lang).replace('--ENV--', position > -1 ? (cov_1murhee27c.b[0][0]++, currentUrl.substring(position, position + 4)) : (cov_1murhee27c.b[0][1]++, ''));
};

/**
 * maps the array that receives as argument to a label object in the form that the cookie-overlay
 * component needs.
 * @param {Array} array containing objects with a property "assetId" that represents the
 * type of the content and a name that represents the content itself
 */
cov_1murhee27c.s[6]++;
var mapLabels = function mapLabels(rawLabels) {
  var _ref;

  cov_1murhee27c.f[1]++;

  var labelsMap = (cov_1murhee27c.s[7]++, (_ref = {}, _defineProperty(_ref, _constants.CRM_COOKIES_TITLE_KEY, 'title'), _defineProperty(_ref, _constants.CRM_COOKIES_BUTTON_KEY, 'button'), _defineProperty(_ref, _constants.CRM_COOKIES_TEXT_KEY, 'text'), _ref));
  var labels = (cov_1murhee27c.s[8]++, {});
  cov_1murhee27c.s[9]++;
  rawLabels.forEach(function (rawObj) {
    cov_1murhee27c.f[2]++;

    var labelType = (cov_1murhee27c.s[10]++, labelsMap[rawObj.assetId]);
    cov_1murhee27c.s[11]++;
    if (labelType) {
      cov_1murhee27c.b[1][0]++;
      cov_1murhee27c.s[12]++;

      labels[labelType] = rawObj.name;
    } else {
      cov_1murhee27c.b[1][1]++;
    }
  });
  cov_1murhee27c.s[13]++;
  return labels;
};

/**
 * finds what language is on site based on wfLanguageConfig.obLanguage
 * @return {string} representing languageCode
 */
cov_1murhee27c.s[14]++;
var getLangFromConfig = function getLangFromConfig() {
  cov_1murhee27c.f[3]++;
  cov_1murhee27c.s[15]++;

  return (cov_1murhee27c.b[2][0]++, window.wfLanguageConfig) && (cov_1murhee27c.b[2][1]++, window.wfLanguageConfig.obLanguage);
};

function getSportsbookLocale() {
  cov_1murhee27c.f[4]++;
  cov_1murhee27c.s[16]++;

  return (cov_1murhee27c.b[3][0]++, window.WH) && (cov_1murhee27c.b[3][1]++, window.WH.sportsbook) && (cov_1murhee27c.b[3][2]++, window.WH.sportsbook.lang);
}

/**
 * tries to fetch the content for the current language, if not available,
 * tries to get the content in english.
 * When it gets content, retrieves the labels and publish the display event
 * @returns {Promise}
 */
cov_1murhee27c.s[17]++;
var getLabels = function getLabels(langCode) {
  cov_1murhee27c.f[5]++;
  cov_1murhee27c.s[18]++;

  /**
   * Fetch the content from the endpoint,
   * if the endpoint is not available or the data that it contains is empty
   * throws an exception
   * @param {string} url where to fetch the content from
   * @return {Promise} containing the data in json format
   */
  var fetchContent = function fetchContent(url) {
    cov_1murhee27c.f[6]++;
    cov_1murhee27c.s[19]++;

    return fetch(url).then(function (response) {
      cov_1murhee27c.f[7]++;
      cov_1murhee27c.s[20]++;
      return response.json();
    }).then(function (_ref2) {
      var Dictionary = _ref2.Dictionary;
      cov_1murhee27c.f[8]++;
      cov_1murhee27c.s[21]++;

      if (Dictionary.length) {
        cov_1murhee27c.b[4][0]++;
        cov_1murhee27c.s[22]++;

        return Dictionary;
      } else {
        cov_1murhee27c.b[4][1]++;
      }
      cov_1murhee27c.s[23]++;
      throw Error('No content in the source');
    }) // If success, display the banner with those labels
    .then(function (data) {
      cov_1murhee27c.f[9]++;
      cov_1murhee27c.s[24]++;

      publish(_constants.MSG_COOKIES_CONSENT_PUB_DISPLAY, mapLabels(data));
    });
  };

  var lang = (cov_1murhee27c.s[25]++, (cov_1murhee27c.b[5][0]++, langCode) || (cov_1murhee27c.b[5][1]++, (0, _cookieAdapter.getItem)(_constants.CRM_COOKIES_LANGUAGE_KEY)) || (cov_1murhee27c.b[5][2]++, getLangFromConfig()) || (cov_1murhee27c.b[5][3]++, getSportsbookLocale()));

  cov_1murhee27c.s[26]++;
  return (
    // We first try to fetch from the current language url
    fetchContent(getContentUrl(lang)) // If error, we log the error and try with english language
    .catch(function (error1) {
      cov_1murhee27c.f[10]++;
      cov_1murhee27c.s[27]++;

      logError('First attempt:', error1.message);
      cov_1murhee27c.s[28]++;
      return fetchContent(getContentUrl('en-gb')) // If error, nothing else to try, log error
      .catch(function (error2) {
        cov_1murhee27c.f[11]++;
        cov_1murhee27c.s[29]++;

        logError('Second attempt:', error2.message);
      });
    })
  );
};
/**
 * Initialses the listeners for the messages sent
 * from the cookies overlay.
 *
 * @returns {void}
 * @private
 */
cov_1murhee27c.s[30]++;
var initListeners = function initListeners() {
  cov_1murhee27c.f[12]++;
  cov_1murhee27c.s[31]++;

  var handleAcceptance = function handleMessages(topic) {
    cov_1murhee27c.f[13]++;
    cov_1murhee27c.s[32]++;

    (0, _cookieAdapter.setItem)(_constants.CRM_COOKIES_CONSENT_KEY, '', 3600 * 24 * 365 * 10); // 10 years
    cov_1murhee27c.s[33]++;
    moduleMessageBus.unsubscribe(topic);
  };

  cov_1murhee27c.s[34]++;
  moduleMessageBus.subscribe(_constants.MSG_COOKIES_CONSENT_SUB_ACCEPTED, handleAcceptance);
};

/**
 * Check if it is native IOS app version >= 10
 *
 * @returns {boolean}  true if it is native IOS app version >= 10.
 * @private
 */
cov_1murhee27c.s[35]++;
var isIOSNative = function isIOSNative() {
  cov_1murhee27c.f[14]++;

  var whDevice = (cov_1murhee27c.s[36]++, (0, _cookieAdapter.getItem)(_constants.CRM_COOKIES_DEVICE));
  cov_1murhee27c.s[37]++;
  if (typeof whDevice !== 'undefined') {
    cov_1murhee27c.b[6][0]++;
    cov_1murhee27c.s[38]++;

    try {
      cov_1murhee27c.s[39]++;

      whDevice = JSON.parse(whDevice);
    } catch (e) {
      cov_1murhee27c.s[40]++;

      logInfo('COOKIE BANNER: could not parce cookie payload');
      cov_1murhee27c.s[41]++;
      return false;
    }
    cov_1murhee27c.s[42]++;
    return (cov_1murhee27c.b[7][0]++, whDevice.is_native) && (cov_1murhee27c.b[7][1]++, whDevice.device_os === 'ios') && (cov_1murhee27c.b[7][2]++, whDevice.app_version >= 10);
  } else {
    cov_1murhee27c.b[6][1]++;
  }
  cov_1murhee27c.s[43]++;
  logInfo('COOKIE BANNER: wh_device cookie not found');
  cov_1murhee27c.s[44]++;
  return false;
};

/**
 * Check if the cookis overlay needs to be displayed.
 *
 * @returns {boolean}         true if the overlay had been already displayed.
 * @private
 */
cov_1murhee27c.s[45]++;
var meetsConditions = function meetsConditions() {
  cov_1murhee27c.f[15]++;
  cov_1murhee27c.s[46]++;

  return !(0, _cookieAdapter.isItemSet)(_constants.CRM_COOKIES_CONSENT_KEY);
};

/**
 * Launchs the cookies overlay.
 *
 * @returns {void}
 * @private
 */
cov_1murhee27c.s[47]++;
var start = function start(langCode) {
  cov_1murhee27c.f[16]++;
  cov_1murhee27c.s[48]++;

  initListeners();
  cov_1murhee27c.s[49]++;
  return getLabels(langCode);
};

/**
 * Entry point for the cookies overlay module.
 *
 * @returns  {void}
 * @public
 */
cov_1murhee27c.s[50]++;
var cookiesOverlay = function cookiesOverlay(messageBus, langCode) {
  cov_1murhee27c.f[17]++;
  cov_1murhee27c.s[51]++;

  moduleMessageBus = messageBus;
  cov_1murhee27c.s[52]++;
  publish = (cov_1murhee27c.b[8][0]++, messageBus.publishSticky) || (cov_1murhee27c.b[8][1]++, messageBus.publish);

  cov_1murhee27c.s[53]++;
  if (isIOSNative()) {
    cov_1murhee27c.b[9][0]++;
    cov_1murhee27c.s[54]++;

    logInfo('COOKIE BANNER: not showing in native IOS app version >= 10');
    cov_1murhee27c.s[55]++;
    return null;
  } else {
    cov_1murhee27c.b[9][1]++;
  }
  cov_1murhee27c.s[56]++;
  if (meetsConditions()) {
    cov_1murhee27c.b[10][0]++;
    cov_1murhee27c.s[57]++;

    return start(langCode);
  } else {
    cov_1murhee27c.b[10][1]++;
  }
  cov_1murhee27c.s[58]++;
  logInfo('COOKIE BANNER: not showing it again, cookie set');
  cov_1murhee27c.s[59]++;
  return null;
};

exports.default = cookiesOverlay;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, Promise) {/*** IMPORTS FROM imports-loader ***/
(function() {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = options.status === undefined ? 200 : options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/*** EXPORTS FROM exports-loader ***/
module.exports = global.fetch;
}.call(global));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(7)))

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate) {

// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var setTimeoutFunc = setTimeout;

function noop() {}

// Polyfill for Function.prototype.bind
function bind(fn, thisArg) {
  return function() {
    fn.apply(thisArg, arguments);
  };
}

function Promise(fn) {
  if (!(this instanceof Promise))
    throw new TypeError('Promises must be constructed via new');
  if (typeof fn !== 'function') throw new TypeError('not a function');
  this._state = 0;
  this._handled = false;
  this._value = undefined;
  this._deferreds = [];

  doResolve(fn, this);
}

function handle(self, deferred) {
  while (self._state === 3) {
    self = self._value;
  }
  if (self._state === 0) {
    self._deferreds.push(deferred);
    return;
  }
  self._handled = true;
  Promise._immediateFn(function() {
    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
      return;
    }
    var ret;
    try {
      ret = cb(self._value);
    } catch (e) {
      reject(deferred.promise, e);
      return;
    }
    resolve(deferred.promise, ret);
  });
}

function resolve(self, newValue) {
  try {
    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
    if (newValue === self)
      throw new TypeError('A promise cannot be resolved with itself.');
    if (
      newValue &&
      (typeof newValue === 'object' || typeof newValue === 'function')
    ) {
      var then = newValue.then;
      if (newValue instanceof Promise) {
        self._state = 3;
        self._value = newValue;
        finale(self);
        return;
      } else if (typeof then === 'function') {
        doResolve(bind(then, newValue), self);
        return;
      }
    }
    self._state = 1;
    self._value = newValue;
    finale(self);
  } catch (e) {
    reject(self, e);
  }
}

function reject(self, newValue) {
  self._state = 2;
  self._value = newValue;
  finale(self);
}

function finale(self) {
  if (self._state === 2 && self._deferreds.length === 0) {
    Promise._immediateFn(function() {
      if (!self._handled) {
        Promise._unhandledRejectionFn(self._value);
      }
    });
  }

  for (var i = 0, len = self._deferreds.length; i < len; i++) {
    handle(self, self._deferreds[i]);
  }
  self._deferreds = null;
}

function Handler(onFulfilled, onRejected, promise) {
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, self) {
  var done = false;
  try {
    fn(
      function(value) {
        if (done) return;
        done = true;
        resolve(self, value);
      },
      function(reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      }
    );
  } catch (ex) {
    if (done) return;
    done = true;
    reject(self, ex);
  }
}

Promise.prototype['catch'] = function(onRejected) {
  return this.then(null, onRejected);
};

Promise.prototype.then = function(onFulfilled, onRejected) {
  var prom = new this.constructor(noop);

  handle(this, new Handler(onFulfilled, onRejected, prom));
  return prom;
};

Promise.prototype['finally'] = function(callback) {
  var constructor = this.constructor;
  return this.then(
    function(value) {
      return constructor.resolve(callback()).then(function() {
        return value;
      });
    },
    function(reason) {
      return constructor.resolve(callback()).then(function() {
        return constructor.reject(reason);
      });
    }
  );
};

Promise.all = function(arr) {
  return new Promise(function(resolve, reject) {
    if (!arr || typeof arr.length === 'undefined')
      throw new TypeError('Promise.all accepts an array');
    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return resolve([]);
    var remaining = args.length;

    function res(i, val) {
      try {
        if (val && (typeof val === 'object' || typeof val === 'function')) {
          var then = val.then;
          if (typeof then === 'function') {
            then.call(
              val,
              function(val) {
                res(i, val);
              },
              reject
            );
            return;
          }
        }
        args[i] = val;
        if (--remaining === 0) {
          resolve(args);
        }
      } catch (ex) {
        reject(ex);
      }
    }

    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.resolve = function(value) {
  if (value && typeof value === 'object' && value.constructor === Promise) {
    return value;
  }

  return new Promise(function(resolve) {
    resolve(value);
  });
};

Promise.reject = function(value) {
  return new Promise(function(resolve, reject) {
    reject(value);
  });
};

Promise.race = function(values) {
  return new Promise(function(resolve, reject) {
    for (var i = 0, len = values.length; i < len; i++) {
      values[i].then(resolve, reject);
    }
  });
};

// Use polyfill for setImmediate for performance gains
Promise._immediateFn =
  (typeof setImmediate === 'function' &&
    function(fn) {
      setImmediate(fn);
    }) ||
  function(fn) {
    setTimeoutFunc(fn, 0);
  };

Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
  if (typeof console !== 'undefined' && console) {
    console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
  }
};

module.exports = Promise;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8).setImmediate))

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(9);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(10)))

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cov_2gkwczxvbs = function () {
  var path = '/builds/CS-Development/overlay-messaging/src/main/components/cookies-consent/constants.js',
      hash = '53c718c52125e686075576934555d1fb533ae40a',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/builds/CS-Development/overlay-messaging/src/main/components/cookies-consent/constants.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 47
        },
        end: {
          line: 1,
          column: 74
        }
      },
      '1': {
        start: {
          line: 2,
          column: 49
        },
        end: {
          line: 2,
          column: 78
        }
      },
      '2': {
        start: {
          line: 3,
          column: 48
        },
        end: {
          line: 3,
          column: 76
        }
      },
      '3': {
        start: {
          line: 4,
          column: 39
        },
        end: {
          line: 4,
          column: 44
        }
      },
      '4': {
        start: {
          line: 5,
          column: 40
        },
        end: {
          line: 5,
          column: 51
        }
      },
      '5': {
        start: {
          line: 7,
          column: 2
        },
        end: {
          line: 7,
          column: 185
        }
      },
      '6': {
        start: {
          line: 8,
          column: 37
        },
        end: {
          line: 8,
          column: 46
        }
      },
      '7': {
        start: {
          line: 9,
          column: 38
        },
        end: {
          line: 9,
          column: 47
        }
      },
      '8': {
        start: {
          line: 10,
          column: 36
        },
        end: {
          line: 10,
          column: 45
        }
      },
      '9': {
        start: {
          line: 11,
          column: 34
        },
        end: {
          line: 11,
          column: 45
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0
    },
    f: {},
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MSG_COOKIES_CONSENT_PUB_DISPLAY = exports.MSG_COOKIES_CONSENT_PUB_DISPLAY = (cov_2gkwczxvbs.s[0]++, 'cp.cookiesConsent.display');
var MSG_COOKIES_CONSENT_SUB_DISPLAYED = exports.MSG_COOKIES_CONSENT_SUB_DISPLAYED = (cov_2gkwczxvbs.s[1]++, 'cp.cookiesConsent.displayed');
var MSG_COOKIES_CONSENT_SUB_ACCEPTED = exports.MSG_COOKIES_CONSENT_SUB_ACCEPTED = (cov_2gkwczxvbs.s[2]++, 'cp.cookiesConsent.accepted');
var CRM_COOKIES_CONSENT_KEY = exports.CRM_COOKIES_CONSENT_KEY = (cov_2gkwczxvbs.s[3]++, 'cdb');
var CRM_COOKIES_LANGUAGE_KEY = exports.CRM_COOKIES_LANGUAGE_KEY = (cov_2gkwczxvbs.s[4]++, 'cust_lang');
var CRM_COOKIES_CONTENT_URL = exports.CRM_COOKIES_CONTENT_URL = (cov_2gkwczxvbs.s[5]++, 'https://search.williamhill--ENV--.com/gaming/s/search.html?collection=translations-api&profile=_default&form=translation&meta_module=legal&num_ranks=99999999&fmo=1&sort=metaposition');
var CRM_COOKIES_TITLE_KEY = exports.CRM_COOKIES_TITLE_KEY = (cov_2gkwczxvbs.s[6]++, '1167580');
var CRM_COOKIES_BUTTON_KEY = exports.CRM_COOKIES_BUTTON_KEY = (cov_2gkwczxvbs.s[7]++, '1167613');
var CRM_COOKIES_TEXT_KEY = exports.CRM_COOKIES_TEXT_KEY = (cov_2gkwczxvbs.s[8]++, '1167594');
var CRM_COOKIES_DEVICE = exports.CRM_COOKIES_DEVICE = (cov_2gkwczxvbs.s[9]++, 'wh_device');

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cov_24jsvueb23 = function () {
  var path = '/builds/CS-Development/overlay-messaging/src/main/adapters/cookieAdapter.js',
      hash = '90d620c02347fbfa35d38e67cef4668ed521d5d9',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/builds/CS-Development/overlay-messaging/src/main/adapters/cookieAdapter.js',
    statementMap: {
      '0': {
        start: {
          line: 12,
          column: 16
        },
        end: {
          line: 25,
          column: 1
        }
      },
      '1': {
        start: {
          line: 13,
          column: 17
        },
        end: {
          line: 16,
          column: 14
        }
      },
      '2': {
        start: {
          line: 18,
          column: 16
        },
        end: {
          line: 18,
          column: 18
        }
      },
      '3': {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 22,
          column: 3
        }
      },
      '4': {
        start: {
          line: 20,
          column: 20
        },
        end: {
          line: 20,
          column: 74
        }
      },
      '5': {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 35
        }
      },
      '6': {
        start: {
          line: 24,
          column: 2
        },
        end: {
          line: 24,
          column: 75
        }
      },
      '7': {
        start: {
          line: 36,
          column: 16
        },
        end: {
          line: 44,
          column: 1
        }
      },
      '8': {
        start: {
          line: 38,
          column: 19
        },
        end: {
          line: 38,
          column: 94
        }
      },
      '9': {
        start: {
          line: 38,
          column: 63
        },
        end: {
          line: 38,
          column: 93
        }
      },
      '10': {
        start: {
          line: 40,
          column: 2
        },
        end: {
          line: 42,
          column: 3
        }
      },
      '11': {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 53
        }
      },
      '12': {
        start: {
          line: 43,
          column: 2
        },
        end: {
          line: 43,
          column: 19
        }
      },
      '13': {
        start: {
          line: 55,
          column: 18
        },
        end: {
          line: 57,
          column: 1
        }
      },
      '14': {
        start: {
          line: 56,
          column: 2
        },
        end: {
          line: 56,
          column: 45
        }
      },
      '15': {
        start: {
          line: 63,
          column: 19
        },
        end: {
          line: 65,
          column: 1
        }
      },
      '16': {
        start: {
          line: 64,
          column: 2
        },
        end: {
          line: 64,
          column: 69
        }
      }
    },
    fnMap: {
      '0': {
        name: 'setItem',
        decl: {
          start: {
            line: 12,
            column: 25
          },
          end: {
            line: 12,
            column: 32
          }
        },
        loc: {
          start: {
            line: 12,
            column: 68
          },
          end: {
            line: 25,
            column: 1
          }
        },
        line: 12
      },
      '1': {
        name: 'getItem',
        decl: {
          start: {
            line: 36,
            column: 25
          },
          end: {
            line: 36,
            column: 32
          }
        },
        loc: {
          start: {
            line: 36,
            column: 38
          },
          end: {
            line: 44,
            column: 1
          }
        },
        line: 36
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 38,
            column: 53
          },
          end: {
            line: 38,
            column: 54
          }
        },
        loc: {
          start: {
            line: 38,
            column: 63
          },
          end: {
            line: 38,
            column: 93
          }
        },
        line: 38
      },
      '3': {
        name: 'isItemSet',
        decl: {
          start: {
            line: 55,
            column: 27
          },
          end: {
            line: 55,
            column: 36
          }
        },
        loc: {
          start: {
            line: 55,
            column: 42
          },
          end: {
            line: 57,
            column: 1
          }
        },
        line: 55
      },
      '4': {
        name: 'deleteItem',
        decl: {
          start: {
            line: 63,
            column: 28
          },
          end: {
            line: 63,
            column: 38
          }
        },
        loc: {
          start: {
            line: 63,
            column: 44
          },
          end: {
            line: 65,
            column: 1
          }
        },
        line: 63
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 12,
            column: 38
          },
          end: {
            line: 12,
            column: 50
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 12,
            column: 48
          },
          end: {
            line: 12,
            column: 50
          }
        }],
        line: 12
      },
      '1': {
        loc: {
          start: {
            line: 12,
            column: 52
          },
          end: {
            line: 12,
            column: 66
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 12,
            column: 65
          },
          end: {
            line: 12,
            column: 66
          }
        }],
        line: 12
      },
      '2': {
        loc: {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        }, {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        }],
        line: 19
      },
      '3': {
        loc: {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 42,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 42,
            column: 3
          }
        }, {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 42,
            column: 3
          }
        }],
        line: 40
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0
    },
    b: {
      '0': [0],
      '1': [0],
      '2': [0, 0],
      '3': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
cov_24jsvueb23.s[0]++;
/**
 * Store a value in a cookie.
 *
 * @param  {string}  key                The key for the value.
 * @param  {string}  payload            The value to store. Empty string by default.
 * @param  {number}  expiration         The optional lifespan of the stored
 *                                        value in seconds.
 * @returns {void}
 *
 * @public
 */
var setItem = function setItem(key) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_24jsvueb23.b[0][0]++, '');
  var expiration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (cov_24jsvueb23.b[1][0]++, 0);
  cov_24jsvueb23.f[0]++;

  var domain = (cov_24jsvueb23.s[1]++, window.location.hostname.split('.').splice(1).join('.'));

  var expData = (cov_24jsvueb23.s[2]++, '');
  cov_24jsvueb23.s[3]++;
  if (expiration > 0) {
    cov_24jsvueb23.b[2][0]++;

    var expDate = (cov_24jsvueb23.s[4]++, new Date(Date.now() + 1000 * expiration).toUTCString());
    cov_24jsvueb23.s[5]++;
    expData = 'expires=' + expDate;
  } else {
    cov_24jsvueb23.b[2][1]++;
  }

  cov_24jsvueb23.s[6]++;
  document.cookie = key + '=' + payload + ';path=/;domain=' + domain + ';' + expData;
};

/**
 * Reads a cookie with a given name from a cookie.
 *
 * @param   {string}  key               The name of the cookie.
 *
 * @returns  {Object}                   The value stored in the cookie.
 *
 * @public
 */
cov_24jsvueb23.s[7]++;
var getItem = function getItem(key) {
  cov_24jsvueb23.f[1]++;

  // Filters the array and returns just the cookie we're interested in.
  var myCookie = (cov_24jsvueb23.s[8]++, document.cookie.split(';').filter(function (cookie) {
    cov_24jsvueb23.f[2]++;
    cov_24jsvueb23.s[9]++;
    return cookie.indexOf(key + '=') > -1;
  }));

  cov_24jsvueb23.s[10]++;
  if (myCookie.length) {
    cov_24jsvueb23.b[3][0]++;
    cov_24jsvueb23.s[11]++;

    return myCookie[0].replace(key + '=', '').trim();
  } else {
    cov_24jsvueb23.b[3][1]++;
  }
  cov_24jsvueb23.s[12]++;
  return undefined;
};

/**
 * Checks whether a cookie with a given name is set.
 *
 * @param   {string}  key               The name of the cookie.
 *
 * @returns  {Boolean}                  Boolean value whether cookie is set or not.
 *
 * @public
 */
cov_24jsvueb23.s[13]++;
var isItemSet = function isItemSet(key) {
  cov_24jsvueb23.f[3]++;
  cov_24jsvueb23.s[14]++;

  return typeof getItem(key) !== 'undefined';
};

/**
 * Delete a cookie with a given name
 * @param {string} key The name of the cookie.
 */
cov_24jsvueb23.s[15]++;
var deleteItem = function deleteItem(key) {
  cov_24jsvueb23.f[4]++;
  cov_24jsvueb23.s[16]++;

  document.cookie = key + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};
exports.getItem = getItem;
exports.setItem = setItem;
exports.isItemSet = isItemSet;
exports.deleteItem = deleteItem;

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports=function(e){var t={};function i(n){if(t[n])return t[n].exports;var r=t[n]={i:n,l:!1,exports:{}};return e[n].call(r.exports,r,r.exports,i),r.l=!0,r.exports}return i.m=e,i.c=t,i.d=function(e,t,n){i.o(e,t)||Object.defineProperty(e,t,{configurable:!1,enumerable:!0,get:n})},i.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return i.d(t,"a",t),t},i.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},i.p="",i(i.s=0)}([function(e,t,i){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n,r=i(1),o=i(2),u=i(3),c=(n=u)&&n.__esModule?n:{default:n};i(4);var s=void 0,a=function(){s.publish(o.MSG_COOKIES_CONSENT_PUB_ACCEPTED,{}),(0,r.clearOverlay)()},l=function(){s.publish(o.MSG_COOKIES_CONSENT_PUB_READMORE,{})},M=function(){s.subscribe(o.MSG_COOKIES_CONSENT_SUB_DISPLAY,function(e,t){var i,n;i=t,(n=document.getElementById("toolbar"))?(0,r.renderOverlay)(n,(0,c.default)(i),"cookie-disclaimer__holder--toolbar"):(0,r.renderOverlay)(document.body,(0,c.default)(i),"cookie-disclaimer__holder"),(0,r.bindOverlayEvents)("click","a",l),(0,r.bindOverlayEvents)("click",".cookie-disclaimer__button",a),s.publish(o.MSG_COOKIES_CONSENT_PUB_DISPLAYED,{})})};t.default=function(e){(function(e){return e&&e.publish&&e.subscribe})(e)&&(s=e,M())}},function(e,t,i){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=void 0,r=function(){return n};t.getOverlay=r,t.bindOverlayEvents=function(e,t,i){var n=r().querySelector(t);n&&(n.removeEventListener(e,i),n.addEventListener(e,i))},t.clearOverlay=function(){n&&n.parentNode.removeChild(n)},t.renderOverlay=function(e,t){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"";return(n=document.createElement("div")).classList.add(i),n.innerHTML=t,e.insertBefore(n,e.firstChild),n}},function(e,t,i){"use strict";Object.defineProperty(t,"__esModule",{value:!0});t.MSG_COOKIES_CONSENT_SUB_DISPLAY="cp.cookiesConsent.display",t.MSG_COOKIES_CONSENT_PUB_DISPLAYED="cp.cookiesConsent.displayed",t.MSG_COOKIES_CONSENT_PUB_ACCEPTED="cp.cookiesConsent.accepted",t.MSG_COOKIES_CONSENT_PUB_READMORE="cp.cookieConsent.readMore"},function(e,t,i){"use strict";e.exports=function(e){return"<div class=cookie-disclaimer><i class=cookie-disclaimer__cookie></i><div class=cookie-disclaimer__main><span class=cookie-disclaimer__title>"+e.title+"</span> <span class=cookie-disclaimer__text>"+e.text+"</span></div><button class=cookie-disclaimer__button>"+e.button+"</button></div>"}},function(e,t,i){var n=i(5);"string"==typeof n&&(n=[[e.i,n,""]]);var r={hmr:!0,transform:void 0};i(9)(n,r);n.locals&&(e.exports=n.locals)},function(e,t,i){var n=i(6);(e.exports=i(7)(!1)).push([e.i,".cookie-disclaimer{background-color:#fff;box-shadow:0 19px 38px 0 #00143c,0 15px 12px 0 #00143c;color:#000;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;font-family:Verdana,Helvetica,Arial,sans-serif;font-size:11px;margin:0 auto;max-width:1440px;z-index:97}@media only screen and (max-width:768px){.cookie-disclaimer{-ms-flex-direction:column;flex-direction:column}}.cookie-disclaimer__holder{bottom:0;position:fixed;width:100%;z-index:97}.cookie-disclaimer__holder--toolbar{bottom:0;left:0;position:fixed;right:0;z-index:20}@media only screen and (max-width:1025px){.cookie-disclaimer__holder{bottom:50px}}.cookie-disclaimer__cookie{background:url("+n(i(8))+") no-repeat;display:block;height:56px;line-height:0;margin:12px;margin-left:24px;min-width:54px;width:54px}@media only screen and (max-width:768px){.cookie-disclaimer__cookie{display:none}}.cookie-disclaimer__main{-ms-flex-direction:column;flex-direction:column;line-height:12px;margin:12px}.cookie-disclaimer__main span{display:block}.cookie-disclaimer__title{font-size:12px;font-weight:700;line-height:12px;margin-bottom:6px}.cookie-disclaimer__text{font-size:11px;-webkit-text-size-adjust:100%}.cookie-disclaimer__button{background-color:#faff05;border:1px solid #e6e504;cursor:pointer;line-height:12px;margin:12px;margin-top:0;min-width:124px;padding:12px}@media only screen and (min-width:769px){.cookie-disclaimer__button{margin:auto 12px;margin-right:24px;width:124px}}",""])},function(e,t){e.exports=function(e){return"string"!=typeof e?e:(/^['"].*['"]$/.test(e)&&(e=e.slice(1,-1)),/["'() \t\n]/.test(e)?'"'+e.replace(/"/g,'\\"').replace(/\n/g,"\\n")+'"':e)}},function(e,t){e.exports=function(e){var t=[];return t.toString=function(){return this.map(function(t){var i=function(e,t){var i=e[1]||"",n=e[3];if(!n)return i;if(t&&"function"==typeof btoa){var r=(u=n,"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(u))))+" */"),o=n.sources.map(function(e){return"/*# sourceURL="+n.sourceRoot+e+" */"});return[i].concat(o).concat([r]).join("\n")}var u;return[i].join("\n")}(t,e);return t[2]?"@media "+t[2]+"{"+i+"}":i}).join("")},t.i=function(e,i){"string"==typeof e&&(e=[[null,e,""]]);for(var n={},r=0;r<this.length;r++){var o=this[r][0];"number"==typeof o&&(n[o]=!0)}for(r=0;r<e.length;r++){var u=e[r];"number"==typeof u[0]&&n[u[0]]||(i&&!u[2]?u[2]=i:i&&(u[2]="("+u[2]+") and ("+i+")"),t.push(u))}},t}},function(e,t){e.exports="data:image/svg+xml;base64,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"},function(e,t,i){var n,r,o={},u=(n=function(){return window&&document&&document.all&&!window.atob},function(){return void 0===r&&(r=n.apply(this,arguments)),r}),c=function(e){var t={};return function(e){if(void 0===t[e]){var i=function(e){return document.querySelector(e)}.call(this,e);if(i instanceof window.HTMLIFrameElement)try{i=i.contentDocument.head}catch(e){i=null}t[e]=i}return t[e]}}(),s=null,a=0,l=[],M=i(10);function I(e,t){for(var i=0;i<e.length;i++){var n=e[i],r=o[n.id];if(r){r.refs++;for(var u=0;u<r.parts.length;u++)r.parts[u](n.parts[u]);for(;u<n.parts.length;u++)r.parts.push(j(n.parts[u],t))}else{var c=[];for(u=0;u<n.parts.length;u++)c.push(j(n.parts[u],t));o[n.id]={id:n.id,refs:1,parts:c}}}}function d(e,t){for(var i=[],n={},r=0;r<e.length;r++){var o=e[r],u=t.base?o[0]+t.base:o[0],c={css:o[1],media:o[2],sourceMap:o[3]};n[u]?n[u].parts.push(c):i.push(n[u]={id:u,parts:[c]})}return i}function f(e,t){var i=c(e.insertInto);if(!i)throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");var n=l[l.length-1];if("top"===e.insertAt)n?n.nextSibling?i.insertBefore(t,n.nextSibling):i.appendChild(t):i.insertBefore(t,i.firstChild),l.push(t);else if("bottom"===e.insertAt)i.appendChild(t);else{if("object"!=typeof e.insertAt||!e.insertAt.before)throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");var r=c(e.insertInto+" "+e.insertAt.before);i.insertBefore(t,r)}}function g(e){if(null===e.parentNode)return!1;e.parentNode.removeChild(e);var t=l.indexOf(e);t>=0&&l.splice(t,1)}function p(e){var t=document.createElement("style");return e.attrs.type="text/css",A(t,e.attrs),f(e,t),t}function A(e,t){Object.keys(t).forEach(function(i){e.setAttribute(i,t[i])})}function j(e,t){var i,n,r,o;if(t.transform&&e.css){if(!(o=t.transform(e.css)))return function(){};e.css=o}if(t.singleton){var u=a++;i=s||(s=p(t)),n=N.bind(null,i,u,!1),r=N.bind(null,i,u,!0)}else e.sourceMap&&"function"==typeof URL&&"function"==typeof URL.createObjectURL&&"function"==typeof URL.revokeObjectURL&&"function"==typeof Blob&&"function"==typeof btoa?(i=function(e){var t=document.createElement("link");return e.attrs.type="text/css",e.attrs.rel="stylesheet",A(t,e.attrs),f(e,t),t}(t),n=function(e,t,i){var n=i.css,r=i.sourceMap,o=void 0===t.convertToAbsoluteUrls&&r;(t.convertToAbsoluteUrls||o)&&(n=M(n));r&&(n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(r))))+" */");var u=new Blob([n],{type:"text/css"}),c=e.href;e.href=URL.createObjectURL(u),c&&URL.revokeObjectURL(c)}.bind(null,i,t),r=function(){g(i),i.href&&URL.revokeObjectURL(i.href)}):(i=p(t),n=function(e,t){var i=t.css,n=t.media;n&&e.setAttribute("media",n);if(e.styleSheet)e.styleSheet.cssText=i;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(i))}}.bind(null,i),r=function(){g(i)});return n(e),function(t){if(t){if(t.css===e.css&&t.media===e.media&&t.sourceMap===e.sourceMap)return;n(e=t)}else r()}}e.exports=function(e,t){if("undefined"!=typeof DEBUG&&DEBUG&&"object"!=typeof document)throw new Error("The style-loader cannot be used in a non-browser environment");(t=t||{}).attrs="object"==typeof t.attrs?t.attrs:{},t.singleton||"boolean"==typeof t.singleton||(t.singleton=u()),t.insertInto||(t.insertInto="head"),t.insertAt||(t.insertAt="bottom");var i=d(e,t);return I(i,t),function(e){for(var n=[],r=0;r<i.length;r++){var u=i[r];(c=o[u.id]).refs--,n.push(c)}e&&I(d(e,t),t);for(r=0;r<n.length;r++){var c;if(0===(c=n[r]).refs){for(var s=0;s<c.parts.length;s++)c.parts[s]();delete o[c.id]}}}};var L,y=(L=[],function(e,t){return L[e]=t,L.filter(Boolean).join("\n")});function N(e,t,i,n){var r=i?"":n.css;if(e.styleSheet)e.styleSheet.cssText=y(t,r);else{var o=document.createTextNode(r),u=e.childNodes;u[t]&&e.removeChild(u[t]),u.length?e.insertBefore(o,u[t]):e.appendChild(o)}}},function(e,t){e.exports=function(e){var t="undefined"!=typeof window&&window.location;if(!t)throw new Error("fixUrls requires window.location");if(!e||"string"!=typeof e)return e;var i=t.protocol+"//"+t.host,n=i+t.pathname.replace(/\/[^\/]*$/,"/");return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi,function(e,t){var r,o=t.trim().replace(/^"(.*)"$/,function(e,t){return t}).replace(/^'(.*)'$/,function(e,t){return t});return/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(o)?e:(r=0===o.indexOf("//")?o:0===o.indexOf("/")?i+o:n+o.replace(/^\.\//,""),"url("+JSON.stringify(r)+")")})}}]);

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (level) {
  return function logger() {
    /* eslint-disable no-console */
    if (console) {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (level === 'error' && console.error) {
        console.error.apply(null, args);
      } else if (false) {
        console[level].apply(null, args);
      }
    }
    /* eslint-enable */
  };
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _messageBusMap = __webpack_require__(16);

var _messageBusMap2 = _interopRequireDefault(_messageBusMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Use the messageBusMap to get the proper messageBus
 * object depending on user's location.
 * @return {Object} The object to use as messageBus
 */
var getMessageBus = function getMessageBus() {
  if ((typeof _messageBusMap2.default === 'undefined' ? 'undefined' : _typeof(_messageBusMap2.default)) === 'object' && _messageBusMap2.default !== null) {
    var location = window.location.href;

    var nameFromMap = void 0;
    Object.keys(_messageBusMap2.default).some(function (option) {
      nameFromMap = option;
      return _messageBusMap2.default[option].some(function (locationRegex) {
        return location.match(locationRegex);
      });
    });

    var messageBusInstance = window;
    nameFromMap.split('.').forEach(function (property) {
      messageBusInstance = messageBusInstance[property];
    });

    return messageBusInstance || getFallbackMessageBus();
  }
  return getFallbackMessageBus();
};

function getFallbackMessageBus() {
  return window.WH && window.WH.messageBus || null;
}

exports.default = getMessageBus;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable */
exports.default = {
  'WH.messageBus': [/^(http|https)(\:\/\/)(www\.williamhill)(-pp1|-pp2|-pp3){0,1}(\.com|\.es)(\/|\/en-gb|\/es|\/pt|\/fi|\/de-de|\/ja-jp|\/cs|\/hu|\/sl|\/ro|\/sr|\/ru-ru|\/el-gr|\/zh-cn|\/zh-hk|\/fr-fr|\/pl-pl){0,1}/i, /^(http|https)(\:\/\/)(sports\.williamhill)(-pp1|-pp2|-pp3){0,1}(\.com)(\/betting\/)(de-de|en-gb|sv-se|el-gr|ru-ru|ja-jp)/i, /^(http|https)(\:\/\/)(sports\.williamhill)(-pp1|-pp2|-pp3){0,1}(\.es)(\/betting\/)(es-es)/i, /^(http|https)(\:\/\/)(sports\.williamhill)(-pp1|-pp2|-pp3){0,1}(\.it)(\/betting\/)(it-it)/i, /^(http|https)(\:\/\/)(vegas\.williamhill)(-pp1|-pp2|-pp3){0,1}(\.com\/en-gb)/i, /^(http|https)(\:\/\/)(livecasino\.williamhill)(-pp1|-pp2|-pp3){0,1}(\.com)(\/|\/en-ie|\/en-ca){0,1}/i, /^(http|https)(\:\/\/)(casino\.williamhill)(-pp1|-pp2|-pp3){0,1}(\.com)(\/|\/en-ie|\/en-ca|\/de-de|\/ru-ru|\/ja-jp|\/en-ca|\/sv-se|\/pl-pl|\/fr-fr){0,1}/i, /^(http|https)(\:\/\/)(games\.williamhill)(-pp1|-pp2|-pp3){0,1}(\.com)(\/|\/en-ie|\/en-ca|\/de-de|\/ru-ru|\/ja-jp|\/sv-se|\/pl-pl|\/el-gr|\/fr-fr){0,1}/i, /^(http|https)(\:\/\/)(bingo\.williamhill)(-pp1|-pp2|-pp3){0,1}(\.com\/en-gb)/i, /^(http|https)(\:\/\/)(promotions\.williamhill)(-pp1|-pp2|-pp3){0,1}(\.com)(\/|\/en-gb|\/ru-ru|\/ja-jp|\/de-de){0,1}/i, /^(http|https)(\:\/\/)(promociones\.williamhill)(-pp1|-pp2|-pp3){0,1}(\.es)/i, /^(http|https)(\:\/\/)(macau\.williamhill)(-pp1|-pp2|-pp3){0,1}(\.com)(\/|\/en-ie|\/en-ca|\/de-de|\/ru-ru|\/ja-jp|\/sv-se|\/pl-pl|\/el-gr|\/fr-fr){0,1}/i, /^(http|https)(\:\/\/)(localhost)/i],
  AnalyticsPubSub: [/^(http|https)(\:\/\/)(vegas\.williamhill)(-pp1|-pp2|-pp3){0,1}(\.com\/)(es|sv|de|ja|ru|cn|zh|fr|pl)(\/live-casino)/i, /^(http|https)(\:\/\/)(games\.williamhill)(-pp1|-pp2|-pp3){0,1}(\.com\/)(es|cn|zh)(\/index)/i, /^(http|https)(\:\/\/)(poker\.williamhill)(-pp1|-pp2|-pp3){0,1}(\.com)(\/|(\/pt|\/ie|\/sv|\/fi|\/de|\/ja|\/cs|\/hu|\/sl|\/ro|\/sr|\/ru|\/es)\/index){0,1}/i]
};

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// overlay-bundle.js